import request from '@/lib/request'

export function getKycAuthUrl(params = {}) {
  return request.post('/api/v1/rental/kyc/auth-url', params);
}

export function getAuthResult(params = {}) {
  return request.post('/api/v1/rental/kyc/auth-result', params);
}

export function startKycSession(params = {}) {
  return request.post('/api/v2/kyc/sessions', params);
}

export function getKycDocumentUploadUrl(sessionId, params = {}) {
  return request.post(`/api/v2/kyc/sessions/${sessionId}/document-upload-url`, params);
}

export function submitKycDocument(sessionId, params = {}) {
  return request.post(`/api/v2/kyc/sessions/${sessionId}/document`, params);
}

export function completeKycSession(sessionId, params = {}, config = {}) {
  return request.post(`/api/v2/kyc/sessions/${sessionId}/complete`, params, config);
}

export function retryKycSession(sessionId) {
  return request.post(`/api/v2/kyc/sessions/${sessionId}/retry`);
}

export function getKycSession(sessionId, config = {}) {
  return request.get(`/api/v2/kyc/sessions/${sessionId}`, {}, config);
}
